<template>
  <div class="news-content">
    <h1>最新咨询</h1>

    <div class="news-item" v-for="(news, index) in newsList" :key="index">
      <router-link :to="{ name: 'NewsDetail', params: { id: index } }">
        <h2>{{ news.title }}</h2>
      </router-link>
      <p class="news-meta">Posted on {{ news.date }} by {{ news.author }}</p>
      <p>{{ news.description }}</p>
      <p v-if="news.details">
        时间: {{ news.details.time }} 地点: {{ news.details.location }}
      </p>
      <div class="news-footer">
        <span>Posted in {{ news.categories.join(", ") }}</span>
       
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsView",
  data() {
    return {
      newsList: []
    };
  },
  mounted() {
    // 通过 fetch 请求 JSON 数据
    fetch("/news.json")
      .then(response => response.json())
      .then(data => {
        this.newsList = data; // 原始数据保持不变
      })
      .catch(error => console.error("Error loading news:", error));
  },
  computed: {
    sortedNewsList() {
      return [...this.newsList].sort((a, b) => {
        const dateA = new Date(a.date); // 直接解析 "Month Day, Year" 格式
        const dateB = new Date(b.date); // 直接解析 "Month Day, Year" 格式
        return dateB - dateA; // 倒序排序
      });
    }
  }
};
</script>
<style scoped>
.news-content {
  padding: 1.25rem; /* 20px -> 1.25rem */
}

a {
  text-decoration: none;
}

.news-item {
  margin-bottom: 1.875rem; /* 30px -> 1.875rem */
  border-bottom: 1px solid #ddd;
  padding-bottom: 1.25rem; /* 20px -> 1.25rem */
}

.news-item h2 {
  font-size: 1.5rem; /* 字号使用 rem 单位 */
  margin-bottom: 0.3125rem; /* 5px -> 0.3125rem */
}

.news-meta {
  font-size: 0.9rem; /* 字号使用 rem 单位 */
  color: #555;
  margin-bottom: 0.625rem; /* 10px -> 0.625rem */
}

.news-footer {
  font-size: 0.85rem; /* 字号使用 rem 单位 */
  color: #777;
}

.comment-link {
  margin-left: 0.625rem; /* 10px -> 0.625rem */
  color: #140a66; /* 紫色 */
  text-decoration: none;
}

.comment-link:hover {
  text-decoration: underline;
}
</style>
